const FETCH_PERMISSIONS_REQUEST = "FETCH_PERMISSIONS_REQUEST";
const FETCH_PERMISSIONS_SUCCESS = "FETCH_PERMISSIONS_SUCCESS";
const FETCH_PERMISSIONS_FAILURE = "FETCH_PERMISSIONS_FAILURE";

export default {
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE,
};
